// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDnHzBlAoO9DNYHiKfWgS8ZDupMZ0HJdkI",
    authDomain: "rs3-dev-pankaj.firebaseapp.com",
    databaseURL: "https://rs3-dev-pankaj.firebaseio.com/",
    projectId: "rs3-dev-pankaj",
    storageBucket: "gs://rs3-dev-pankaj.appspot.com",
    messagingSenderId: "381512281555"
  },
  apiUrl :  'http://localhost:5000/rs3-dev-pankaj/us-central1/rsApp/',  // 'https://us-central1-rs3-dev-pankaj.cloudfunctions.net/rsApp/',  //
  appUrl:'https://rs3-dev-pankaj.firebaseapp.com/', // 
  algolia : {
    appId : "M334Z1967M",
    adminAPIKey: "fe6c70f67ece51c225b91fb7f006230f"
  }

  
  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
